var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"become-an-author become-an-author-btn",attrs:{"href":_vm.link,"open-in-new-tab":false}},[_vm._v("\n  Become an author\n")])}
var staticRenderFns = []

export { render, staticRenderFns }